import { motion } from "framer-motion";
import { formatCurrency } from "../../../data/mock/dashboardData";

export default function WeeklyPulseChart({ days }) {
  const rows = Array.isArray(days) ? days : [];
  const weekTotal = rows.reduce((sum, d) => sum + (Number(d.amount) || 0), 0);

  if (!rows.length || !weekTotal) {
    return (
      <div className="flex h-full min-h-[220px] flex-1 flex-col">
        <p className="flex flex-1 items-center justify-center text-sm text-primary/40">
          No collections this week yet.
        </p>
        <p className="mt-3 text-center text-[11px] text-primary/40">
          Week total · <span className="font-bold text-primary">{formatCurrency(0)}</span>
        </p>
      </div>
    );
  }

  const max = Math.max(1, ...rows.map((d) => Number(d.amount) || 0));

  return (
    <div className="flex h-full min-h-[220px] flex-1 flex-col">
      <div className="flex flex-1 items-end justify-between gap-1.5 sm:gap-2">
        {rows.map((day, i) => {
          const amount = Number(day.amount) || 0;
          const pct = (amount / max) * 100;
          const isPeak = amount === max && amount > 0;
          return (
            <div
              key={day.label || i}
              className="flex h-full min-w-0 flex-1 flex-col items-center justify-end gap-2"
            >
              <span className="text-[10px] font-bold text-primary/70">{formatCurrency(amount)}</span>
              <div className="relative flex w-full flex-1 flex-col justify-end">
                <motion.div
                  className="w-full origin-bottom rounded-t-xl"
                  style={{
                    height: `${Math.max(pct, amount > 0 ? 8 : 2)}%`,
                    minHeight: amount > 0 ? "8%" : "2%",
                    background: isPeak
                      ? "linear-gradient(180deg, #E5B80B 0%, #B91C1C 100%)"
                      : "linear-gradient(180deg, #DC2626 0%, #B91C1C 100%)",
                  }}
                  initial={{ scaleY: 0, opacity: 0 }}
                  animate={{ scaleY: 1, opacity: 1 }}
                  transition={{ duration: 0.55, delay: 0.08 + i * 0.07, ease: "easeOut" }}
                />
              </div>
              <span className="shrink-0 text-[10px] font-medium text-primary/45">
                {day.label}
              </span>
            </div>
          );
        })}
      </div>
      <p className="mt-3 text-center text-[11px] text-primary/40">
        Week total · <span className="font-bold text-primary">{formatCurrency(weekTotal)}</span>
      </p>
    </div>
  );
}
